<div class="empty-panel"></div>

<div class="side-panel">

    <div class="row">
        <div class="col title">{{'CampList.title' | translate}}</div>
    </div>


    <form [formGroup]="searchForm" novalidate class="voffset-20">

        <div class="row form-group form-horizontal">
            <div class="col-12">
                <label class="panel-label">{{ 'CampSearch.name' | translate }}</label>
                <input maxlength="200" class="form-control" hznTestId="camp-list-name" formControlName="name">
            </div>
        </div>

        <hr />

        <div class="form-group form-horizontal voffset20">
            <label class="panel-label">{{ 'CampSearch.club' | translate }}</label>
            <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="clubDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true"
                hznTestId="camp-list-club"
                (changed)="onClubsChanged($event)">
            </bcu-drop-down-multiselect-cf2>
        </div>

        <hr />

        <div class="form-group form-horizontal voffset20">
            <label class="panel-label">{{ 'CampSearch.category' | translate }}</label>
            <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="categoriesDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true"
                hznTestId="camp-list-category"
                (changed)="onCategoryChanged($event)">
            </bcu-drop-down-multiselect-cf2>
        </div>

        <hr />

        <div class="form-group form-horizontal voffset20">
            <label class="panel-label">{{ 'CampSearch.campType' | translate }}</label>
            <bcu-drop-down-multiselect-cf2 [isDisabled]="isBusy" [options]="campTypeDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true"
                hznTestId="camp-list-camp-type"
                (changed)="onCampTypeChanged($event)">
            </bcu-drop-down-multiselect-cf2>
        </div>

        <hr />

        <div class="voffset-20 form-check">
            <bcu-tri-state-checkbox hznTestId="camp-list-visibility" formControlName="visibility" [label]="'CampSearch.visibleInConnect' | translate">
            </bcu-tri-state-checkbox>
        </div>

        <div class="voffset-20 form-check">
            <label class="form-check-label">
                <bcu-tri-state-checkbox hznTestId="camp-list-historical" formControlName="historical" [label]="'CampSearch.showHistorical' | translate">
                </bcu-tri-state-checkbox>
            </label>
        </div>

    </form>
</div>
